const facedownCards = {
  WC26: require('./wc26_card.png'),
  F1: require('./f1_card.png'),
  NBA: require('./nba_card.png'),
  TENNIS: require('./tennis_card.png'),
  INVESTORS: require('./investors_card.png'),
  SINGERS: require('./singers_card.png'),
  ARTISTS: require('./singers_card.png'),
};

export default facedownCards;
